import { UserOutlined } from "@ant-design/icons";
import { Statistic } from "antd";
import { useContext, useEffect, useState } from "react";
import { getAllPatients } from "./utils";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import ".././App.css";

const PatientsHeader = ({ title }: { title: string }) => {
  const [PatientX, setPatientX] = useState<number | undefined>(undefined);

  const signedInDoctor: SignedInDoctor =
    useContext(SignedInContext).signedInDoctor;

  useEffect(() => {
    getAllPatients(signedInDoctor).then((fetchedPatients) => {
      const totalPatients = fetchedPatients.length;
      //console.log(`Numero totale di pazienti: ${totalPatients}`);
      setPatientX(totalPatients);
    });
  }, [signedInDoctor]);

  return (
    <h2 className="header-section-title">
      <span className="texta">{PatientX}</span>
      <UserOutlined rev={undefined} />
      <span style={{ marginLeft: "5px" }}>{title}</span>
    </h2>
  );
};

export default PatientsHeader;
